import { render } from "./hykd.vue?vue&type=template&id=51c6ba98&scoped=true&ts=true"
import script from "./hykd.vue?vue&type=script&lang=ts"
export * from "./hykd.vue?vue&type=script&lang=ts"

import "./hykd.vue?vue&type=style&index=0&id=51c6ba98&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c6ba98"]])

export default __exports__